import { green, blue, orange, purple } from '@mui/material/colors';
import r from '../Utils/fetch';

const w: any = window;
const getConnectorsV2Url = () =>
	w.API_CONNECTORS_CONFIG_URL || w.API_CONNECTORS_V2_URL || 'http://localhost:8080';

export interface IStatus {
	id: number;
	name: string;
	color?: string;
}

export const ConnectorStatusAlpha = 50,
	ConnectorStatusComingSoon = 100,
	ConnectorStatusBeta = 150,
	ConnectorStatusActive = 200;

export const ConnectorStatusLst: IStatus[] = [
	{
		id: ConnectorStatusAlpha,
		name: 'Alpha',
		color: purple[500],
	},
	{
		id: ConnectorStatusComingSoon,
		name: 'Coming Soon',
		color: orange[500],
	},
	{
		id: ConnectorStatusBeta,
		name: 'Beta',
		color: blue[500],
	},
	{
		id: ConnectorStatusActive,
		name: 'Actif',
		color: green[500],
	},
];

// updateConnectorStatus appelle api-connectors-v2 (SoT du status connecteur)
// pour patcher qm_connectors.status. Toute valeur valide (50/100/150/200) est
// acceptée, pas de contrainte de transition côté backend.
export const updateConnectorStatus = (id: number, status: number): Promise<any> =>
	r({
		url: `${getConnectorsV2Url()}/v1/admin/connectors/${id}/status`,
		method: 'PATCH',
		data: { status },
	});
